<template>
  <v-dialog v-model="dialog.show" max-width="700" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <!-- <v-col cols="6">
              <v-text-field
                v-model="financiamento.custoRegistro"
                label="Custo de Registro"
                :rules="[rules.required, rules.isNumber]"
                prefix="$"
              ></v-text-field>
            </v-col> -->
            <v-col cols="6">
              <v-text-field
                v-model="financiamento.taxaCadastro"
                label="Taxa de Cadastro"
                :rules="[rules.required, rules.isNumber]"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                v-model="financiamento.editarValorVeic"
                label="Editar Valor do Veiculo"
              ></v-checkbox>
            </v-col>
            <!-- <v-col cols="6">
              <v-checkbox
                v-model="financiamento.adcPercVeicValorBase"
                label="Adiciona Percentual Sobre Valor Base"
              ></v-checkbox>
              <v-btn
                elevation="2"
                rounded
                x-small
                color="primary"
                outlined
                v-show="financiamento.adcPercVeicValorBase"
                @click="$refs.tableVeiculoAdcPerc.show(financiamento)"
                >Adicionar Percentual</v-btn
              >
            </v-col> -->
            <v-col cols="12">
              <v-textarea
                v-model="financiamento.shareText"
                label="Texto para Compartilhar"
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
      <TableVeiculoAdcPerc ref="tableVeiculoAdcPerc" />
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Parametro from "@/services/parametro";

export default {
  name: "DialogFormFinanciamento",

  components: {
    TableVeiculoAdcPerc: () => import("./TableVeiculoAdcPerc"),
  },

  data() {
    return {
      dialog: {
        show: false,
        title: "",
      },
      financiamento: {
        empresa: "",
        id: "",
        adcPercVeicValorBase: false,
        custoRegistro: "",
        taxaCadastro: "",
        textoCompartilhar: "",
        editarValorVeic: "",
        addPercentualTabelaVeic: {},
      },
      serviceParametro: new Parametro(),
      rules,
    };
  },

  methods: {
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.formatValuesToFloat();
          const response = await this.serviceParametro.updateParametro({
            ...this.financiamento,
          });
          this.$emit("updated", { ...this.financiamento });
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao editar parametro Financiamento");
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog.show = false;
    },

    show(item) {
      this.financiamento = { ...item };
      this.dialog.title = "Editar Parametro Financiamento";
      this.dialog.edit = true;
      this.dialog.show = true;
    },

    formatValuesToFloat() {
      this.financiamento.custoRegistro = parseFloat(
        this.financiamento.custoRegistro
      );
      this.financiamento.taxaCadastro = parseFloat(
        this.financiamento.taxaCadastro
      );
    },
  },
};
</script>
